import React, { useEffect, useState } from 'react';
import OrderStepper from './order-stepper';
import Timer from './timer';
import { UserDeadline } from '../constants/localStorageKeys';
import { selectIsPublicSale } from '../redux/saleTypeSlice';
import { useSelector } from 'react-redux';
import { selectStockItemsStats } from '../redux/stockItemsStatsSlice';
import { showToastError } from './toastNotification';

const PageHeader = ({ currentStepNumber, backToHomepage, isDelayTimerAction }) => {
  const steps = {
    1: "CONNECT WALLET",
    2: "QUIZ",
    3: "SHIPPING INFORMATION",
    4: "CONFIRMATION CHECKOUT",
    100: "QUEUE"
  };

  const stepToStepperNum = {
    1: 1,
    2: 2,
    3: 3,
    100: 3,
    4: 4,
  }

  const stockInfo = useSelector(selectStockItemsStats);

  const isPublicSale = useSelector(selectIsPublicSale);

  const actionOnExpiredTimer = () => {
    localStorage.removeItem(UserDeadline);
    showToastError({ title: 'Payment failed', body: 'The payment window has expired'});
    backToHomepage && backToHomepage();
  }

  return (
    <>
      <p className='sale-type-header'>{isPublicSale ? 'PUBLIC SALE' : 'PRIVATE SALE'}</p>

      <Timer isActive={currentStepNumber >= 3 && currentStepNumber <= 4} actionOnExpired={actionOnExpiredTimer} additionalText="Time to buy -" isTempStopCheck={isDelayTimerAction}/>

      {/* { currentStepNumber >= 1 && currentStepNumber <= 2 &&
        <p className='remain-stock-items'>Items in stock : {stockInfo.inventory}</p>
      } */}

      <div className='page-header'>
        <h2>LVLCS x WORLD MOBILE TOKEN FOOTBALL JERSEY IRL</h2>

        <div className='order-stepper'>
          <OrderStepper currentStepNumber={stepToStepperNum[currentStepNumber]}/>
        </div>

        <h4>{steps[currentStepNumber]}</h4>
      </div>
    </>
  );
};

export default PageHeader;